export default __webpack_public_path__ + "static/media/recreate2.0dc6488f.png";